export const GROUP_QUESTIONS_DIALOG_ROOT = 'membership questions modal';
export const GROUP_QUESTIONS_DIALOG_SUBMIT_BUTTON =
  'membership questions submit button';
